// extracted by mini-css-extract-plugin
export default {"header":"UWModal_header__rwH6-","content":"UWModal_content__v8fVw"};